export default "__VITE_ASSET__DvCgn_ZR__"